<ng-container
  ><span *ngIf="countryDisplayMode === 'CLUB'">{{ clubMember.clubName }}</span>
  <span *ngIf="countryDisplayMode === 'COUNTRY'">
    <span *ngIf="clubMember.countryCode"> {{'country.' + clubMember.countryCode + '.name' | translate }} </span>
  </span>
  <span *ngIf="countryDisplayMode === 'COUNTRY_AND_CLUB'">
    {{ clubMember.clubName }}
    <span *ngIf="clubMember.countryCode"> ({{'country.' + clubMember.countryCode + '.name' | translate }}) </span>
  </span>
</ng-container>
